export const DEFAULT_LANGUAGE = 'ru'
export const DEFAULT_TLD = 'ru'
